import * as actionTypes from '../actionTypes/NewShippingActionTypes';

/**
 * Ship to home and store section
 */

/* Update Reducer */
const updateShippingType = (value) => ({
    type: actionTypes.UPDATE_SHIPPING_TYPE,
    value,
});

const updateShippingMethodList = (orderDetails) => ({
    type: actionTypes.UPDATE_SHIPPING_METHOD_LIST,
    orderDetails,
});

/* Call Saga */
const submitShippingSection = () => ({
    type: actionTypes.SUBMIT_SHIPPING_SECTION,
});

/**
 * Ship to home section
 */

/* Update Reducer */
const initShippingSectionUI = (isLoadedFromReview, orderDetails, addressList, context) => ({
    type: actionTypes.INIT_SHIP_TO_HOME_SECTION_UI,
    isLoadedFromReview,
    orderDetails,
    addressList,
    context,
});

/**
 * Init Ship to home section
 */

/* Update Reducer */
const initNewShippingSectionUI = () => ({
    type: actionTypes.INIT_NEW_SHIPPING_SECTION,
});

const updateShippingAddressFormValue = (attribute, newValue) => ({
    type: actionTypes.UPDATE_SHIPPING_ADDRESS_FORM,
    attribute,
    newValue,
});

const updateShippingAddressFormError = (errorInfo) => ({
    type: actionTypes.UPDATE_SHIPPING_ADDRESS_FORM_ERROR,
    errorInfo,
});

const updateShippingAddressFormFieldError = (attribute) => ({
    type: actionTypes.UPDATE_SHIPPING_ADDRESS_FIELD_ERROR,
    attribute,
});

const setNewShippingAddressStandNotRequired = (value) => ({
    type: actionTypes.SET_NEW_SHIPPING_ADDRESS_STAND_NOT_REQUIRED,
    value,
});

const updateShippingMethod = (code) => ({
    type: actionTypes.UPDATE_SHIPPING_METHOD,
    code,
});

const editShippingAddress = (address) => ({
    type: actionTypes.EDIT_SHIPPING_ADDRESS,
    address,
});

const addShippingAddress = () => ({
    type: actionTypes.ADD_SHIPPING_ADDRESS,
});

const cancelAddEditShippingAddress = () => ({
    type: actionTypes.CANCEL_ADD_EDIT_SHIPPING_ADDRESS,
});

const showDeleteShippingAddressWarning = (shippingAddressId, isDefault) => ({
    type: actionTypes.SHOW_DELETE_SHIPPING_ADDRESS_WARNING,
    shippingAddressId,
    isDefault,
});

const changeShippingAddressUI = (selectedShippingAddress, orderDetails) => ({
    type: actionTypes.CHANGE_SHIPPING_ADDRESS_UI,
    selectedShippingAddress,
    orderDetails,
});

const showAllShippingAddresses = (value) => ({
    type: actionTypes.SHOW_ALL_SHIPPING_ADDRESSES,
    value,
});

const setExpressShippingAddress = (value) => ({
    type: actionTypes.SET_EXPRESS_CHECKOUT_ADDRESS,
    value,
});

const setStreetAddressCheckExecuted = (value) => ({
    type: actionTypes.SET_STREET_ADDRESS_CHECK_EXECUTED,
    value,
});

/* Call Saga */

const submitNewShippingAddressForm = (showDeliveryOption = false) => ({
    type: actionTypes.SUBMIT_NEW_SHIPPING_ADDRESS_FORM,
    showDeliveryOption,
});

const fetchCityStateByZip = (zipCode, isEmptyForm = false) => ({
    type: actionTypes.FETCH_CITY_STATE_BY_ZIP,
    zipCode,
    isEmptyForm,
});

const deleteShippingAddressFromProfile = () => ({
    type: actionTypes.DELETE_SHIPPING_ADDRESS_FROM_PROFILE,
});

const changeShippingAddressRequest = (address) => ({
    type: actionTypes.CHANGE_SHIPPING_ADDRESS_REQUEST,
    address,
});

const changeShippingAddressOnCancel = (address) => ({
    type: actionTypes.CHANGE_SHIPPING_ADDRESS_ON_CANCEL,
    address,
});

const clearUserInputAddress = (context) => ({
    type: actionTypes.CLEAR_USER_INPUT_ADDRESS,
    context,
});

const submitSTHShippingSelection = () => ({
    type: actionTypes.SUBMIT_STH_SHIPPING_SELECTION,
});

/**
 * Ship to store section
 */

/* Update reducer */
const initShipToStoreSectionUI = (
    orderDetails,
    storeInfo,
    userStoreList,
    isLoadedFromReview,
    isUserLoggedIn
) => ({
    type: actionTypes.NEW_INIT_SHIP_STORE_SECTION_UI,
    orderDetails,
    storeInfo,
    userStoreList,
    isLoadedFromReview,
    isUserLoggedIn,
});

const updateSTSFormValue = (attribute, newValue) => ({
    type: actionTypes.UPDATE_STS__FORM,
    attribute,
    newValue,
});

const updateSTSFormError = (errorInfo) => ({
    type: actionTypes.UPDATE_STS__FORM_ERROR,
    errorInfo,
});

const updateSTSFormFieldError = (attribute) => ({
    type: actionTypes.UPDATE_STS__FIELD_ERROR,
    attribute,
});

const selectStoreFromProfile = (storeId) => ({
    type: actionTypes.SELECT_STORE_FROM_PROFILE,
    storeId,
});

const updateUserStoreListUI = (storeId, userStoreList) => ({
    type: actionTypes.PROFILE_ADDED_STORE_UPDATE_UI,
    storeId,
    userStoreList,
});

const changeStoreUpdateUI = (storeInfo) => ({
    type: actionTypes.CHANGE_STORE_UPDATE_UI,
    storeInfo,
});

const changeSTSUpdateUI = (storeInfo) => ({
    type: actionTypes.CHANGE_STS_UPDATE_UI,
    storeInfo,
});

/* Call saga */
const addStoreToProfile = (storeId) => ({
    type: actionTypes.NEW_ADD_STORE_TO_PROFILE,
    storeId,
});

// const getBnplAddress = () => ({
//     type: actionTypes.GET_BNPL_ADDRESS,
// });

export {
    initShippingSectionUI,
    initNewShippingSectionUI,
    updateShippingType,
    updateShippingMethodList,
    updateShippingAddressFormValue,
    updateShippingAddressFormError,
    updateShippingAddressFormFieldError,
    setNewShippingAddressStandNotRequired,
    updateShippingMethod,
    editShippingAddress,
    cancelAddEditShippingAddress,
    submitNewShippingAddressForm,
    submitShippingSection,
    submitSTHShippingSelection,
    fetchCityStateByZip,
    addShippingAddress,
    showDeleteShippingAddressWarning,
    deleteShippingAddressFromProfile,
    changeShippingAddressRequest,
    changeShippingAddressUI,
    showAllShippingAddresses,
    initShipToStoreSectionUI,
    addStoreToProfile,
    updateUserStoreListUI,
    selectStoreFromProfile,
    updateSTSFormValue,
    updateSTSFormError,
    updateSTSFormFieldError,
    changeStoreUpdateUI,
    changeSTSUpdateUI,
    setExpressShippingAddress,
    setStreetAddressCheckExecuted,
    changeShippingAddressOnCancel,
    clearUserInputAddress,
};
